import CompraWallapop from "../CompraWallapop";
import HistoricoBajas from "../HistoricoBajas";


export default function Inicio({ }) {
    const user = JSON.parse(localStorage.getItem('user'));
    // Conditional rendering based on rol_id
    return (
        <div className="content">
            {user.rol_id === 4 ? <CompraWallapop /> : <HistoricoBajas />}
        </div>
    );
}